
import { useEffect, useState } from 'react';
import { request } from '../utils/request';

import HouseCard from '../components/HouseCard';

import '../App.css';

const Detail = (props) => {
  const [totalData, setTotalData] = useState({});

  useEffect(() => {
    getTotalData();
  }, [])

  const getTotalData = async () => {
    const res = await request('index');
    setTotalData(res.data);
  }

  const valueFormat = (value) => {
    return value.toString().split('');
  }

  const renderValue = (value) => {
    if (value) {
      return valueFormat(value).map((item, index) => (
        <li key={index}>{item}</li>
      ))
    }
  }

  return (
    <div className="card detail">
      <div className="total-container">
        <div className="total-item">
          <p>生长指数</p>
          <ul>
            {renderValue(totalData.liveIndex)}
            <li>%</li>
          </ul>
        </div>
        <div className="total-item">
          <p>总光照时长</p>
          <ul>
            {renderValue(totalData.sunTime)}
          </ul>
        </div>
        <div className="total-item">
          <p>种植天数</p>
          <ul>
            {renderValue(totalData.plantDays)}
          </ul>
        </div>
      </div>

      <div className="house-container">
        {props.houses.map((item, index) => (
          <div className="house" key={item.hid}>
            <HouseCard house={item} hid={item.hid} index={index} setData={props.setData} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Detail;
